import { useState } from 'react' // added by srini on 16-01-25
import { Grid, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, IconButton } from '@mui/material'
import { TablePagination } from "@material-ui/core" // added by srini on 16-01-25
import { withStyles } from "@material-ui/core/styles"
import styles from "../../TabStyles"
import EditIcon from "@mui/icons-material/Edit"

const UsersTable = ({ classes, handleSortUsers, sortColumn, sortOrder, userData, handleEditUser }) => {
    // added by srini on 16-01-25
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    
    const getSortIcon = (column) => {
        return sortColumn === column ? (sortOrder === 'asc' ? '▼' : '▲') : ''
    }

    // added by srini on 16-01-25
    const handlePageChange = (event, newpage) => {
        setPage(newpage)
    }
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    return (
        <Grid className={classes.horizantalTablayout}>
            <TableContainer>
                <Table sx={{ minWidth: 36 }} aria-label="simple table">
                    <TableHead>
                        <TableRow sx={{ borderBottom: '2px solid black' }}>
                            <TableCell
                                className={classes.tableHeading1}
                                align="left"
                                onClick={() => handleSortUsers('sip_id')}
                                sx={{ cursor: 'pointer' }}
                            >
                                User/Agent ID {getSortIcon('sip_id')}
                            </TableCell>

                            <TableCell
                                className={classes.tableHeading2}
                                align="left"
                                onClick={() => handleSortUsers('name')}
                                sx={{ cursor: 'pointer' }}
                            >
                                Name {getSortIcon('name')}
                            </TableCell>

                            <TableCell className={classes.tableHeading3} align="left">
                                Department
                            </TableCell>

                            <TableCell className={classes.tableHeading3} align="left">
                                Role
                            </TableCell>

                            <TableCell className={classes.tableHeading3} align="left">
                                Action
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {/* added by srini on 16-01-25 */}
                        {userData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => (
                            <TableRow key={item.sip_id} sx={{ borderBottom: '2px solid black' }}>
                                <TableCell align="left" className={classes.rowText}>
                                    {item.sip_id}
                                </TableCell>

                                {/* <TableCell align="left" className={classes.rowText}>
                                    {item.roles?.[0]?.name || '-'}
                                </TableCell> */}

                                <TableCell align="left" className={classes.rowText}>
                                    {item.name}
                                </TableCell>

                             

                                <TableCell align="left" className={classes.rowText}>
                                    {item.departments?.[0]?.name || '-'}
                                </TableCell>

                                <TableCell align="left" className={classes.rowText}>
                                    {item.roles?.[0]?.name || '-'}
                                </TableCell>

                                <TableCell align="left">
                                    <IconButton onClick={() => handleEditUser(item)}>
                                        <EditIcon sx={{ color: '#0083CA', fontSize: '18px' }} />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* added by srini on 16-01-25 */}
            <TablePagination
                className={classes.pagination}
                rowsPerPageOptions={[10, 15, 20]}
                component="div"
                count={userData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Grid>
    )
}

export default withStyles(styles)(UsersTable)